export const DEFAULT_OPT_IN_CONTENT = {
  titleEn: 'Opt into {benefit_name}?',
  contentEn: 'We’ll notify you when it goes live.',
  disclaimerEn:
    'I agree to a salary alteration and / or allowance deduction to cover my contribution where necessary.',
  ctaTextEn: 'Confirm opt-in',
};

export const DEFAULT_OPT_OUT_CONTENT = {
  titleEn: 'Opt out of {benefit_name}?',
  contentEn:
    'You will be able to opt back in before the enrollment window closes.',
  disclaimerEn:
    'I understand that I will not be able to opt in again once the enrollment window closes.',
  ctaTextEn: 'Confirm opt-out',
};

export const DEFAULT_CHANGE_CONTENT = {
  titleEn: 'Confirm changes to {benefit_name}?',
  contentEn:
    'Your changes may affect your salary deductions. Please review before confirming.',
  disclaimerEn:
    'I agree to any salary alteration and / or allowance deduction changes resulting from this update.',
  ctaTextEn: 'Confirm changes',
};
